class LoginPanel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.trigger?.exists) {
      this.handleTrigger = this.handleTrigger.bind(this)

      this.els.trigger.elements.forEach(el => {
        this.listeners.add(el, 'click', this.handleTrigger)
      })
    }
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els.panel.elements.forEach(panelEl => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.tab !== triggerEl.dataset.tab,
      )
    })

    this.els.trigger.elements.forEach(trigger => {
      trigger.setAttribute(
        'aria-pressed',
        trigger.dataset.tab === triggerEl.dataset.tab,
      )
    })
  }
}

if (!customElements.get('login-panel')) {
  customElements.define('login-panel', LoginPanel)
}
